import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/TS.mp4";
import videoSource1 from "../../assets/videos/TS_Demo.mp4";
import architecture from "../../assets/images/resource/text_speech.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import ts from "./../../assets/images/icons/ts.png";
import msa from "./../../assets/images/icons/msa.png";

const TextToSpeech = () => {
  pageTitle("Text To Speech");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper" style={{ backgroundImage: `url(${SorBanner})` }}>
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          />
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2">
              Azure SSML for Expressive <br />
              Voice Synthesis
            </h2>
            <p>
              <img src={ts} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              Text To Speech
            </p>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Convert text into natural, expressive audio with a Microsoft
                Azure AI-powered speech workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution transforms written text into clear,
                natural-sounding speech through a flexible AI voice generation
                workflow:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Nine-Step Workflow
              </p>
              <ol>
                <li>
                  Plain Text Input – Enter the text content to be converted into
                  speech.
                </li>
                <li>
                  Voice Setup – Choose the preferred voice, language, and
                  speaking style.
                </li>
                <li>
                  Prosody Control – Customize pitch, speaking rate, and volume
                  for better delivery.
                </li>
                <li>
                  Emotional Tone – Apply styles such as cheerful, calm, or
                  professional expression.
                </li>
                <li>
                  Natural Pauses – Add pauses to improve rhythm and listener
                  comfort.
                </li>
                <li>
                  Emphasis Control – Highlight important words and phrases for
                  stronger communication.
                </li>
                <li>
                  Language Flexibility – Support multilingual speech within the
                  same audio output.
                </li>
                <li>
                  Pronunciation Support – Refine complex or difficult words for
                  accurate speech generation.
                </li>
                <li>
                  Speech Synthesis Output – Produce high-quality audio in
                  real-time or batch processing mode.
                </li>
              </ol>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated Azure AI Services.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>Azure SSML for Expressive Voice Synthesis</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://ai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure AI Text To Speech
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This infographic illustrates the sophisticated pipeline used to
            transform plain text into lifelike synthetic narration through the
            use of Azure SSML. The process begins by establishing a vocal
            identity through the selection of specific languages and emotional
            personas, which can be further refined by adjusting technical
            elements like pitch, rate, and volume. To achieve true realism, the
            system incorporates structural and linguistic nuances, such as
            strategic pauses and precise pronunciation, ensuring the final audio
            does not sound mechanical. Ultimately, the framework serves as a
            comprehensive guide for developers to master expressive speech
            synthesis, resulting in high-quality output that mimics the natural
            flow of human conversation.
          </p>
          <img
            src={architecture}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Azure AI Text To Speech
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>Azure SSML for Expressive Voice Synthesis</strong>, <br />
            Click 👉{" "}
            <a
              href="https://ai.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Azure AI Text To Speech
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default TextToSpeech;
